// extracted by mini-css-extract-plugin
export default {"container":"ClinicRoutes_container__9benV","sidebar":"ClinicRoutes_sidebar__l0kCv","content":"ClinicRoutes_content__tmodK"};